import $ from 'jquery';
import _ from 'underscore';
import MessageHandler from './jwplayer-message-handler';
import adTagBuilder from './jwplayer-ads';
import Analytics from './jwplayer-quartile-analytics';

class JWPlayerInit {
    constructor() {
        this.adTag = adTagBuilder.adUrl;
        this.$vid = $('#video');
        this.ext = document.createElement('video').canPlayType('video/webm') ? 'webm' : 'mp4';
        this.size = window.innerWidth < 481 ? '480' : '720';
        this.player = {};
        this.playlistCalled = false;
        this.autoplay = (window.location.search.search(/autoplay\=1/) !== -1) ? true : false;
        this.options = {
            file: this.$vid.data('adaptive'),
            image: this.$vid.data('poster'),
            title: this.$vid.data('title'),
            description: this.$vid.data('desc'),
            mediaid: this.$vid.data('id'),
            autostart: this.autoplay,
            advertising: {
                client: 'googima',
                tag: this.adTag
            },
            ga: {}
        };

        // Keep mute options outside the object so they don't reset themselves when player reloads
        this.options.mute = true;
        if (this.autoplay) {
            this.options.mute = false;
        }

        this.playlistOptions = _.extend({}, this.options);
        this.playlistOptions.playlist = '//content.jwplatform.com/feeds/gE5uQSi7.json';
        this.playlistOptions.autostart = true;
    }

    initPlayer() {
        this.player.setup(this.options);

        this.player.on('ready', function () {
            var analytics = new Analytics(this.player, 'videoEmbed');
            analytics.on();
            var messageHandler = new MessageHandler(this.player);
            messageHandler.on();
        }.bind(this));

        this.player.on('complete', function () {
            this.loadPlaylist();
        }.bind(this));

        this.player.on('play', function () {
            if (this.getMute() === true) {
                return this.setCurrentCaptions(1);
            }
            return this.setCurrentCaptions(0);
        });

        this.player.on('mute', function () {
            if (this.getMute() === true) {
                return this.setCurrentCaptions(1);
            }
            return this.setCurrentCaptions(0);
        });

        if (/debug/.test(window.location.search)) {
            this.player.on('all', function (data) {
                console.log(data); // eslint-disable-line no-console
            });
        }
    }

    loadPlaylist() {
        if (!this.playlistCalled) {
            this.player.setup(this.playlistOptions);
            this.playlistCalled = true;
        }
    }

    on() {
        this.player = jwplayer('video');
        this.initPlayer();
    }

    off() {
        this.player = {};
    }
}

export default new JWPlayerInit();
